import { CheckCircleIcon, ExclamationIcon } from "@heroicons/react/outline";

import { SpanStatus } from "@/components/TraceDetail/utils/calculateSpanStatus";
import { Badge, BadgeSize, BadgeVariant } from "@/components/ui/Badge";
import LoadingSpinner from "@/components/LoadingSpinner";

export const StatusCellBadge = ({ status }: { status: SpanStatus }) => {
  switch (status) {
    case SpanStatus.Error:
      return (
        <Badge variant={BadgeVariant.RED} size={BadgeSize.SM}>
          <ExclamationIcon className="h-3 w-3" />
          Error
        </Badge>
      );
    case SpanStatus.Failed:
      return (
        <Badge variant={BadgeVariant.RED} size={BadgeSize.SM}>
          <ExclamationIcon className="h-3 w-3" />
          Failed
        </Badge>
      );
    case SpanStatus.PartiallyFailed:
      return (
        <Badge variant={BadgeVariant.ORANGE} size={BadgeSize.SM}>
          <ExclamationIcon className="h-3 w-3" />
          Partially Failed
        </Badge>
      );
    case SpanStatus.Running:
      return (
        <Badge variant={BadgeVariant.BLUE} size={BadgeSize.SM} animate>
          <LoadingSpinner size={3} className="!mr-0.5" />
          Running
        </Badge>
      );
    case SpanStatus.Success:
      return (
        <Badge variant={BadgeVariant.GREEN} size={BadgeSize.SM}>
          <CheckCircleIcon className="h-3 w-3" />
          Success
        </Badge>
      );
    default:
      return null;
  }
};
